import React, { useState, useEffect } from 'react'
import { ColorPicker, Form, Radio } from 'antd'
import { BarChartOutlined } from '@ant-design/icons'
import { DashboardSettingType, DefaultColor } from '../../../constants/DashboardConf'
import { MultiColorWrapper } from '../dashboard.styled'
import { useTranslation } from 'react-i18next'

const { MAP, PIECHART, BARCHART, LINECHART } = DashboardSettingType
const singleColor = [MAP]
const multipleColor = [PIECHART, BARCHART, LINECHART]
function StyleSetting (props) {
  const { t: ln_t } = useTranslation()
  const { defConfig, type, init, form } = props
  const [colors, setColors] = useState(DefaultColor)

  const handleChange = (key, val) => {
    const newColors = { ...colors, [key]: val.toRgbString() }
    setColors(newColors)
    form.setFieldsValue({ themeColor: newColors })
  }

  useEffect(() => {
    if (!init || !multipleColor?.includes(type)) return
    setColors(init?.UISetting?.style?.themeColor || DefaultColor)
  }, [init])

  return (
    <>
      {singleColor?.includes(type)
        ? <Form.Item {...defConfig('themeColor', 'select')}>
            <ColorPicker showText />
          </Form.Item>
        : ''}

      {type === BARCHART
        ? <Form.Item {...defConfig('chartStyle', 'select')} initialValue="column">
            <Radio.Group
              buttonStyle="solid"
              optionType="button"
              options={[
                { value: 'column', label: <><BarChartOutlined /> {ln_t('dashboard.vertical')}</> },
                { value: 'bar', label: <><BarChartOutlined style={{ transform: 'rotate(90deg) scaleX(-1)' }} /> {ln_t('dashboard.horizontal')}</> }
              ]}
            />
          </Form.Item>
        : ''}
      {multipleColor?.includes(type)
        ? <Form.Item {...defConfig('themeColor', 'select')} initialValue={DefaultColor}>
            <MultiColorWrapper>
              {Object.entries(colors).map(([key, val]) => <ColorPicker key={key} value={val} onChange={e => handleChange(key, e)} />)}
            </MultiColorWrapper>
          </Form.Item>
        : ''}
    </>
  )
}

export default StyleSetting
